// extracted by mini-css-extract-plugin
export var wrapperStyle = "breadcrumbs-module--wrapperStyle--ypr5M";